"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _axios = _interopRequireDefault(require("axios"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _useAddresses = _interopRequireDefault(require("../../../hooks/useAddresses"));
var _getCustomerIdentifier = _interopRequireDefault(require("../../../utils/getCustomerIdentifier"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Item = _interopRequireDefault(require("../Item"));
var _List = _interopRequireDefault(require("./List.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Dialog = (0, _component.default)(() => import("../../Dialog"));
const List = _ref => {
  let {
    lang,
    selected,
    selectable,
    onSelect
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const addresses = (0, _useAddresses.default)();
  const location = (0, _reactRouterDom.useLocation)();
  const navigate = (0, _useLink.default)();
  const hash = location.hash;
  const {
    pathname
  } = location;
  const [deleteDialog, setDeleteDialog] = (0, _react.useState)({
    show: false,
    id: null
  });
  const [addressToDelete, setAddressToDelete] = (0, _react.useState)("");
  const [localAddresses, setLocalAddresses] = (0, _react.useState)([]);
  const customerIdentifier = (0, _getCustomerIdentifier.default)();
  const css = (0, _List.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    setLocalAddresses(addresses);
  }, [addresses]);
  (0, _react.useEffect)(() => {
    if (hash === "") return;
    const now = new Date();
    const hashTimestamp = hash.split(",")[1];

    // show Success Message only if time < 10 sec

    if (hashTimestamp) {
      const hashDate = new Date(parseInt(hashTimestamp));
      if (now.getTime() - hashDate.getTime() <= 10000) {
        setMessageObj({
          message: l("reactShop.messages.success.ADDRESS_SAVED"),
          type: "success"
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, l("reactShop.messages.success.ADDRESS_SAVED")]);
  const handleDelete = (id, address) => {
    setDeleteDialog({
      show: true,
      id: id ? id : 0
    });
    setAddressToDelete(address);
  };
  const handleClose = () => {
    setDeleteDialog({
      show: false,
      id: null
    });
  };
  const handleExecuteDelete = id => {
    const newAddresses = localAddresses === null || localAddresses === void 0 ? void 0 : localAddresses.filter(address => {
      if (id === 0) {
        return address.id !== undefined;
      } else {
        return address.id !== id;
      }
    });
    const loginToken = localStorage.getItem("logintoken");
    let auth = "";
    if (loginToken) {
      auth = "Bearer ".concat(loginToken);
    }

    // delete Address

    _axios.default.delete("".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CustomerApi/AddressREST.api").concat(customerIdentifier ? "?customerIdentifier=".concat(customerIdentifier) : ""), {
      headers: {
        Authorization: auth,
        "Content-Type": "application/json"
      },
      data: {
        id: id
      }
    }).then(response => {
      const {
        data: {
          msg
        } = {}
      } = response;
      if (msg === "ok") {
        setMessageObj({
          message: /*#__PURE__*/_react.default.createElement(_Local.default, {
            identifier: "reactShop.messages.success.ADDRESS_DELETED",
            l: l
          }),
          type: "success"
        });
      }
    });
    setLocalAddresses(newAddresses);
    setDeleteDialog({
      show: false,
      id: null
    });
  };
  const handleEdit = id => {
    navigate(pathname + "/edit/" + (id ? id : 0));
  };
  const handleNew = () => {
    navigate(pathname + "/new");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.list, "mco-shop-addresses")
  }, localAddresses === null || localAddresses === void 0 ? void 0 : localAddresses.map((address, counter) => {
    const {
      id = 0
    } = address;
    return /*#__PURE__*/_react.default.createElement(_Item.default, {
      avoidDelete: localAddresses.length === 1,
      data: address,
      key: counter,
      lang: lang,
      selected: selected === id,
      selectable: selectable,
      onDelete: handleDelete,
      onEdit: handleEdit,
      onSelect: onSelect
    });
  }), /*#__PURE__*/_react.default.createElement(_Item.default, {
    lang: lang,
    newItem: true,
    onClickNew: handleNew
  }), /*#__PURE__*/_react.default.createElement(Dialog, {
    buttonPrimary: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.delete",
      l: l
    }),
    buttonPrimaryAction: () => handleExecuteDelete(deleteDialog.id),
    buttonSecondary: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.cancel",
      l: l
    }),
    buttonSecondaryAction: handleClose,
    handleClose: handleClose,
    openDialog: deleteDialog.show,
    title: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.deleteHeadline",
      l: l
    }),
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.deleteText",
      l: l
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: addressToDelete
      }
    }))
  }));
};
var _default = exports.default = List;